import {useCallback, useState} from "react";

const NAV_LINKS = [
    {label: "Leistungen", href: "#leistungen"},
    {label: "Team", href: "#team"},
    {label: "Kontakt", href: "#kontakt"},
];

export function Navbar(props) {
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = useCallback(() => setMenuOpen(p => !p), []);

    return (
        <>
            <nav className={`nav${props.scrolled ? " nav--scrolled" : ""}`}>
                <div style={{display: "flex", alignItems: "center", gap: "0.75rem"}}>
                    <img
                        src="/bilder/headerLogo.png"
                        alt="Hauarztpraxis Wagner Logo"
                        style={{height: "60px", width: "60px", objectFit: "fill"}}
                    />
                    <div className="logo">
                        Hausarztpraxis Gabriele Wagner
                        <span className="logo__sub">Fachärztin für Allgemeinmedizin, Notfallmedizin und Naturheilverfahren</span>
                    </div>
                </div>

                <ul className="nav-links">
                    {NAV_LINKS.map(({label, href}) => (
                        <li key={label}>
                            <a href={href} className={props.activeSection === href.slice(1) ? "active" : ""}>
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>

                <button className="nav-hamburger" onClick={toggleMenu} aria-label="Menü" aria-expanded={menuOpen}>
                    {menuOpen ? "✕" : "☰"}
                </button>
            </nav>
        </>
    );
}